module.exports = __webpack_public_path__ + "static/media/error.6791a224.svg";